import React, { FC, useEffect, useState } from "react"

import { statisticApi } from "@shared/apis"

interface Props {
  lastWeekday?: string
}

const LastDay: FC<Props> = ({ lastWeekday }) => {
  const [lastDayViewersCount, setLastDayViewersCount] = useState<number>()

  useEffect(() => {
    if (!lastWeekday) return

    const getLastDayViewerCount = async () => {
      const { data: lastDayViewersCount } = await statisticApi.lastDayViewers(
        lastWeekday,
        lastWeekday,
        1,
        1,
      )
      const lastDayStatistic = lastDayViewersCount.content[0]
      lastDayStatistic?.id &&
        setLastDayViewersCount(
          lastDayStatistic.freeMobileAppNonmemberCount +
            lastDayStatistic.freeMobileNonmemberCount +
            lastDayStatistic.freePcNonmemberCount +
            lastDayStatistic.memberCount,
        )
    }

    getLastDayViewerCount()
  }, [lastWeekday])

  return (
    <li className="next">
      <label>전일 누적시청수</label>
      <p className="viewerCount">
        <strong>{lastDayViewersCount?.toLocaleString() ?? "-"}</strong>
      </p>
    </li>
  )
}
export default LastDay
